 // 全局拦截到购物车页的跳转，改为打开 mini-cart 抽屉
// (function () {
//   var CART_URL = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
//   var LAST_CART_REFRESH_TS = 0;
//   var LAST_CART_JSON = null;

//   // 缓存最近一次 cart 更新（来自主题原生的 product-form 或 pageshow 等事件）
//   document.addEventListener('cart:updated', function (e) {
//     try { LAST_CART_JSON = e.detail && e.detail.cart || null; LAST_CART_REFRESH_TS = Date.now(); } catch(_){}
//   });
//   document.addEventListener('cart:refresh', function (e) {
//     try { LAST_CART_JSON = e.detail && e.detail.cart || null; LAST_CART_REFRESH_TS = Date.now(); } catch(_){}
//   });
//   function samePath(a, b) {
//     try {
//       var ua = new URL(a, window.location.origin);
//       var ub = new URL(b, window.location.origin);
//       return ua.pathname === ub.pathname;
//     } catch (e) {
//       return false;
//     }
//   }

//   function openMiniCartWithLatestData() {
//     // 若刚刚有主题派发的 cart:refresh/cart:updated，则直接打开，避免重复网络/重渲染
//     var recentlyRefreshed = (Date.now() - LAST_CART_REFRESH_TS) < 4000 && document.querySelector('cart-drawer#mini-cart');
//     if (recentlyRefreshed) {
//       var drawer = document.querySelector('cart-drawer#mini-cart');
//       if (drawer) { drawer.open = true; return; }
//     }
//     // 否则，拉取最新 cart.json，并派发 cart:refresh 以驱动重渲染与打开
//     fetch(CART_URL + '.js')
//       .then(function (r) { return r.json(); })
//       .then(function (cart) {
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//           bubbles: true,
//           detail: { cart: cart, openMiniCart: true }
//         }));
//       })
//       .catch(function () {
//         var drawer = document.querySelector('cart-drawer#mini-cart');
//         if (drawer) drawer.open = true;
//       });
//   }

//   function closeQuickBuyUIs() {
//     try {
//       // 关闭 Quick Buy 抽屉
//       document.querySelectorAll('quick-buy-drawer, .drawer--quick-buy').forEach(function (el) {
//         // 禁用点击，避免遮挡/误触
//         try { el.style.pointerEvents = 'none'; } catch (_) {}
//         var overlay = el.querySelector ? el.querySelector('.drawer__overlay') : null;
//         if (overlay) { try { overlay.style.pointerEvents = 'none'; } catch (_) {} }
//         if (typeof el.open !== 'undefined') el.open = false;
//         el.removeAttribute && el.removeAttribute('open');
//         el.classList && el.classList.remove('is-open');
//       });
//       // 关闭 Quick Buy 弹层
//       document.querySelectorAll('quick-buy-popover, .popover--quick-buy').forEach(function (el) {
//         try { el.style.pointerEvents = 'none'; } catch (_) {}
//         var overlay = el.querySelector ? el.querySelector('.popover__overlay') : null;
//         if (overlay) { try { overlay.style.pointerEvents = 'none'; } catch (_) {} }
//         if (typeof el.open !== 'undefined') el.open = false;
//         el.removeAttribute && el.removeAttribute('open');
//         el.classList && el.classList.remove('is-open');
//       });
//     } catch (e) {
//       // ignore
//     }
//   }

//   function shouldIntercept() {
//     try {
//       // 仅在主题设置为 drawer 且页面中存在 mini-cart 时生效
//       var isDrawer = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'drawer';
//       var drawerEl = document.querySelector('cart-drawer#mini-cart');
//       return Boolean(isDrawer && drawerEl);
//     } catch (e) {
//       return false;
//     }
//   }

//   document.addEventListener('click', function (evt) {
//     if (!shouldIntercept()) return;
//     var link = evt.target && evt.target.closest && evt.target.closest('a[href]');
//     if (!link) return;

//     if (samePath(link.href, CART_URL)) {
//       evt.preventDefault();
//       // 先关闭变体选择的弹窗/抽屉，再打开 mini-cart
//       closeQuickBuyUIs();
//       // 立即打开 mini-cart（避免中间空挡误操作）
//       // 使用下一帧确保 DOM 状态已更新
//       (window.requestAnimationFrame || setTimeout)(openMiniCartWithLatestData, 0);
//     }
//   }, true);
// })();

 
// Fish Wishlist: keep the wishlist button on the selected variant (theme fires variant:changed on the product form)
document.addEventListener('variant:changed', function (event) {
  var variant = event.detail && event.detail.variant;
  var formId = event.target && event.target.getAttribute('id');
  if (!variant || !formId) return;
  document.querySelectorAll('wishlist-button-pdp[data-form-id="' + formId + '"]').forEach(function (btn) {
    if (btn.updateAfterVariantChange) btn.updateAfterVariantChange({ id: variant.id });
  });
});
// Fish Wishlist: tell the button which variant is selected on page load
if (window.customElements) {
  customElements.whenDefined('wishlist-button-pdp').then(function () {
    document.querySelectorAll('wishlist-button-pdp[data-preselected-id]').forEach(function (btn) {
      if (btn.updateAfterVariantChange) btn.updateAfterVariantChange({ id: btn.getAttribute('data-preselected-id') });
    });
  });
}
